import PropTypes from 'prop-types';
import useAnalyticsEvent from '../../hooks/useAnalyticsEvent';

/**
 * Formats heading text strings. For example: Why CSS Grid? -> why-css-grid
 * @param {string} string
 * @returns string
 */
function formatHeading(string) {
  return string.replace(/\s+/g, '-').replace(/[?!]/g, '').toLowerCase();
}

const H3Heading = ({ children }) => {
  const emitEvent = useAnalyticsEvent();
  const heading = formatHeading(children);

  const onClick = () => {
    emitEvent({
      action: 'headingAnchorClick',
      category: 'headingAnchor',
      label: 'headingAnchorClick',
    });
  };

  return (
    <h3 id={heading}>
      {children}
      <a href={`#${heading}`} onClick={onClick}>#</a>
    </h3>
  );
};

H3Heading.propTypes = {
  children: PropTypes.string.isRequired,
};

export default H3Heading;
